module.exports = __webpack_public_path__ + "img/mc-ab.4fa7674b.png";